import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Services API
export const getServices = async () => {
  const response = await api.get('/api/services');
  return response.data;
};

export const getServiceBySlug = async (slug) => {
  const response = await api.get(`/api/services/${slug}`);
  return response.data;
};

// Testimonials API
export const getTestimonials = async () => {
  const response = await api.get('/api/testimonials');
  return response.data;
};

// Stats API
export const getStats = async () => {
  const response = await api.get('/api/stats');
  return response.data;
};

// Video Projects API
export const getVideoProjects = async () => {
  const response = await api.get('/api/video-projects');
  return response.data;
};

// Geo Pages API
export const getGeoPages = async () => {
  const response = await api.get('/api/geo-pages');
  return response.data;
};

export const getGeoPageBySlug = async (slug) => {
  const response = await api.get(`/api/geo-pages/${slug}`);
  return response.data;
};

// Company Info API
export const getCompanyInfo = async () => {
  const response = await api.get('/api/company-info');
  return response.data;
};

// Blog Posts API
export const getBlogPosts = async () => {
  const response = await api.get('/api/blog-posts');
  return response.data;
};

export const getBlogPostBySlug = async (slug) => {
  const response = await api.get(`/api/blog-posts/${slug}`);
  return response.data;
};

export default api;
